import Footnote from "./footnote";

const GBQ_STATS = [
  {
    title: "13.5%",
    description: <span>of gay gym goers in London report active use of AAS<Footnote num={2}/></span>
  },
  {
    title: "5.2%",
    description: <span>of gay and bisexual men living in Australia report actively using AAS<Footnote num={3}/></span>
  },
  {
    title: "25.4%",
    description: <span>of gay and bisexual men living in Australia report considering using AAS<Footnote num={3}/></span>
  },
  {
    title: "5.8x",
    description: <span>Sexual minority adolescent boys 5.8x more likely to report AAS use compared to heterosexual peers<Footnote num={4}/></span>
  }
];

const ContentSection = (props) => {
  const getAllOptions = () => {
    return props.data.map((item, index) => 
      <div className="content-option" key={`option${index}`}>
        <div className="gbq-stat">
          <p>{item.title}</p>
        </div>
        <p>{item.description}</p>
      </div>
    );
  }

  return (
    <div>
      <div className="content-options">
        {getAllOptions()}
      </div>
    </div>
  );
}

const GBQ = () => {
  return (
    <section className="content-section content-section-boxed">
      <h2>Gay, bisexual, and queer men are disproportionately impacted.</h2>
      <ContentSection data={GBQ_STATS}/>
      <p>
        Multiple reasons may explain these disparities, including: 
        <ul>
          <li>History of prescribing testosterone to individuals with HIV hypogonadism<Footnote num={5}/></li>
          <li>Interaction between sexual orientation and views on masculinity<Footnote num={6}/></li>
          <li>Increased pressures to obtain ideal male physique of lean and muscular<Footnote num={7}/></li>
          <li>(Over)emphasis on appearance<Footnote num={7}/></li>
        </ul>
      </p>
    </section>
  )
}

export default GBQ;